export default __webpack_public_path__ + "static/media/seminar-hall-1.db04aea9.jpg";